import _ from 'lodash';
import React from 'react';
import { InvoiceStatusFilter } from '~/components';
import InvoiceSentFilter from '~/components/filters/InvoiceSentFilter';
import FiltersGroup from './FiltersGroup';
import InvoiceItemFilter from './InvoiceItemFilter';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function InvoiceFiltersGroup({ filters, onChange }) {
  return (
    <FiltersGroup
      label="Invoice Filters"
      filters={[
        filters.invoiceServicesThroughPeriod?.start,
        filters.invoiceServicesThroughPeriod?.end,
        filters.invoiceStatuses,
        filters.invoiceSent,
        filters.invoiceItems,
      ]}>
      {_.has(filters, 'invoiceServicesThroughPeriod') && (
        <ReportPeriodFilter
          value={filters.invoiceServicesThroughPeriod}
          placeholder="Services Through Date Range"
          onChange={({ target: { value } }) => onChange({ invoiceServicesThroughPeriod: value })}
        />
      )}

      {_.has(filters, 'invoiceStatuses') && (
        <InvoiceStatusFilter
          value={filters.invoiceStatuses}
          onChange={({ target: { value } }) => onChange({ invoiceStatuses: value })}
        />
      )}

      {_.has(filters, 'invoiceSent') && (
        <InvoiceSentFilter
          value={filters.invoiceSent}
          onChange={({ target: { value } }) => onChange({ invoiceSent: value })}
        />
      )}

      {_.has(filters, 'invoiceItems') && (
        <InvoiceItemFilter
          value={filters.invoiceItems}
          onChange={({ target: { value } }) => onChange({ invoiceItems: value })}
        />
      )}
    </FiltersGroup>
  );
}
